import React from 'react';
import './style.scss';

export interface UQLabelProps {
  children: React.ReactNode;
  size?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
  className?: string;
  style?: React.CSSProperties;
}

const UQLabel: React.FC<UQLabelProps> = ({
  children,
  size = 'm',
  className = '',
  style,
}) => (
  <span className={`uq-label uq-label-${size} ${className}`} style={style}>
    {children}
  </span>
);

export default UQLabel;